import { Component, Input, OnInit } from '@angular/core';
import { Billing, BillingConcepto, PAYMENT_METHODS, PAYMENT_TYPES, CFDI_USAGES, SATCatalog } from '../../../data/interfaces/billing.interface';

@Component({
  selector: 'app-billing-display',
  templateUrl: './billing-display.component.html',
  styleUrls: ['./billing-display.component.scss']
})
export class BillingDisplayComponent implements OnInit {
  @Input() billing!: Billing;
  @Input() lease?: any;

  // Catálogos SAT para mostrar labels
  private paymentMethods = PAYMENT_METHODS;
  private paymentTypes = PAYMENT_TYPES;
  private cfdiUsages = CFDI_USAGES;

  constructor() {}

  ngOnInit() {}

  /**
   * Conceptos configurados (para la tabla de sólo lectura).
   */
  get conceptos(): BillingConcepto[] {
    return this.billing?.conceptos || [];
  }

  /**
   * Obtener label de método de pago
   */
  getPaymentMethodLabel(): string {
    return this.getLabel(this.paymentMethods, this.billing.paymentMethod);
  }

  /**
   * Obtener label de tipo de pago
   */
  getPaymentTypeLabel(): string {
    return this.getLabel(this.paymentTypes, this.billing.paymentType);
  }

  /**
   * Obtener label de uso de CFDI
   */
  getCfdiUsageLabel(): string {
    return this.getLabel(this.cfdiUsages, this.billing.cfdiUsage);
  }

  /**
   * Obtener label de un catálogo SAT
   */
  private getLabel(catalog: SATCatalog[], value: string): string {
    const item = catalog.find(item => item.value === value);
    return item ? item.label : value;
  }

  /**
   * Formatear fecha
   */
  formatDate(date: Date | string): string {
    if (!date) return 'N/A';
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  /**
   * Verificar si tiene comentarios
   */
  hasComments(): boolean {
    return !!(this.billing.comments && this.billing.comments.trim().length > 0);
  }

  /**
   * Obtener iniciales para avatar
   */
  getBusinessInitials(): string {
    if (!this.billing.businessName) return 'N/A';
    
    const words = this.billing.businessName.split(' ');
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    
    return words.slice(0, 2).map(word => word.charAt(0)).join('').toUpperCase();
  }

  /**
   * Obtener clase CSS para el tipo de pago
   */
  getPaymentTypeClass(): string {
    switch (this.billing.paymentType) {
      case 'PUE':
        return 'payment-type-pue';
      case 'PPD':
        return 'payment-type-ppd';
      default:
        return 'payment-type-default';
    }
  }

  /**
   * Obtener información del lease si está disponible
   */
  getLeaseInfo(): string {
    if (!this.lease) return 'N/A';
    return this.lease.folio || this.lease._id || 'N/A';
  }

  /**
   * Obtener estado del lease
   */
  getLeaseStatus(): string {
    if (!this.lease) return 'N/A';
    return this.lease.status || 'N/A';
  }

  /**
   * Obtener clase CSS para el estado del lease
   */
  getLeaseStatusClass(): string {
    if (!this.lease) return 'status-unknown';
    
    switch (this.lease.status) {
      case 'Activo':
        return 'success';
      case 'Pendiente':
        return 'status-pending';
      case 'Finalizado':
        return 'status-completed';
      default:
        return 'status-unknown';
    }
  }
}